import React from 'react';
import { LocalizedStandardDate } from 'intl/LocalizedComponents';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _find from 'lodash/find';
import _parseInt from 'lodash/parseInt';
import _get from 'lodash/get';
// Core components
import AppLoader from 'components/core/AppLoader';
import Divider from 'components/core/Divider';
import List from 'components/core/List';
// Custom
import { getInstallationDevice, getDeviceInfo, getDeviceSync } from 'actions';
import { deviceDataShape } from 'constants/PropTypesShapes';
import { LastComDateItem, NetworkLevelItem, NetworkOperatorItem } from 'components/items/InformationItems';
import DeviceStatusItem from 'devices/assets/main/DeviceStatusItem';
import DeviceAsyncStatusItem from 'devices/assets/main/DeviceAsyncStatusItem';
import InstallationInformationItem from 'installations/assets/main/InstallationInformationItem';
import SimcardInformationItem from 'simcards/assets/main/SimcardInformationItem';
import DeviceDescItem from './DeviceDescItem';

class DeviceDataTip extends React.Component {
  componentDidMount() {
    const {
      source, parentId, deviceId, deviceWithInfo, handleGetInstallationDevice, handleGetDeviceInfo, handleGetDeviceSync,
    } = this.props;
    if (!deviceWithInfo) {
      // Device not found => load it according to source
      if (source === 'installation') {
        handleGetInstallationDevice(parentId, deviceId);
      } else if (source === 'simcard' || source === 'device' || source === 'rollout' || source === 'deviceSlave') {
        handleGetDeviceInfo(deviceId);
      }
    } else if (!deviceWithInfo.sync_status) {
      // If device is already loaded, check if its sync status must be loaded
      handleGetDeviceSync(deviceWithInfo.id);
    }
  }

  componentDidUpdate(prevProps) {
    const { deviceWithInfo, handleGetDeviceSync } = this.props;
    const { deviceWithInfo: prevDeviceWithInfo } = prevProps;

    // Check if device is loaded to load its sync status
    if (prevDeviceWithInfo && deviceWithInfo && prevDeviceWithInfo.loading && !deviceWithInfo.loading) {
      handleGetDeviceSync(deviceWithInfo.id);
    }
  }

  render() {
    const {
      deviceWithInfo, withDesc, withSimcard, withInstallation,
    } = this.props;

    const loading = !!_get(deviceWithInfo, 'loading');

    if (deviceWithInfo) {
      return (
        <div style={{ width: 270 }}>
          <div className="box box-default" style={{ height: 50, margin: '-4px -8px 0 -8px' }}>
            <div className="box-header box-dark box-title-small d-flex align-items-center justify-content-center">
              {loading ? <AppLoader size={24} /> : <strong>{deviceWithInfo.serial}</strong>}
            </div>
          </div>
          <List disablePadding>
            {withDesc && (
              <React.Fragment>
                <DeviceDescItem device={deviceWithInfo} light />
                <Divider variant="middle" />
              </React.Fragment>
            )}
            {withInstallation && (
              <React.Fragment>
                <InstallationInformationItem installation={deviceWithInfo.installation} light />
                <Divider variant="middle" />
              </React.Fragment>
            )}
            <DeviceStatusItem device={deviceWithInfo} light />
            <Divider variant="middle" />
            <DeviceAsyncStatusItem device={deviceWithInfo} withDetails={false} light />
            <Divider variant="middle" />
            <LastComDateItem value={_get(deviceWithInfo, 'last_comm_date') ? <LocalizedStandardDate value={deviceWithInfo.last_comm_date} /> : null} light />
            <Divider variant="middle" />
            <NetworkOperatorItem networkOperator={_get(deviceWithInfo, 'info.network_operator')} light />
            <Divider variant="middle" />
            <NetworkLevelItem
              networkLevel={_get(deviceWithInfo, 'info.network_level')}
              networkAccessTechnology={_get(deviceWithInfo, 'info.network_access_technology')}
              light
            />
            {withSimcard && (
              <React.Fragment>
                <Divider variant="middle" />
                <SimcardInformationItem simcard={deviceWithInfo.simcard} light />
              </React.Fragment>
            )}
          </List>
        </div>
      );
    }
    return null;
  }
}

DeviceDataTip.propTypes = {
  deviceId: PropTypes.number.isRequired,
  deviceWithInfo: deviceDataShape,
  source: PropTypes.oneOf(['installation', 'simcard', 'device', 'rollout', 'deviceSlave']).isRequired,
  parentId: PropTypes.number,
  withDesc: PropTypes.bool.isRequired,
  withSimcard: PropTypes.bool.isRequired,
  withInstallation: PropTypes.bool.isRequired,
  handleGetInstallationDevice: PropTypes.func.isRequired,
  handleGetDeviceInfo: PropTypes.func.isRequired,
  handleGetDeviceSync: PropTypes.func.isRequired,
};

DeviceDataTip.defaultProps = {
  deviceWithInfo: null,
  parentId: 0,
};

const mapStateToProps = (state, ownProps) => ({
  deviceWithInfo: _find(state.deviceData.withAllInfoElements, ['id', _parseInt(ownProps.deviceId)]),
});

const mapDispatchToProps = (dispatch) => ({
  handleGetInstallationDevice: (id, idDevice) => {
    dispatch(getInstallationDevice(id, idDevice));
  },
  handleGetDeviceInfo: (id) => {
    dispatch(getDeviceInfo(id));
  },
  handleGetDeviceSync: (id) => {
    dispatch(getDeviceSync(id));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
)(DeviceDataTip);



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/main/DeviceDataTip.js